// MARK://dhk8/admin-shell/lib/queries/floor
// Query tipada del plano - F9.5 / ADR-0009. El Admin lee el plano (mapas/secciones/
// mesas) por el grafo (pos-floor), tenant del JWT (RLS). Mismo campo floorMaps que
// ya consume el POS (apps/pos/src/lib/queries/floor.queries.ts).
// F9.17 / ADR-0008: las escrituras de mesas/secciones también van por el grafo
// (create/update/deleteFloorTable + create/deleteFloorSection). El tenantId lo
// pone el JWT (no va en input). F6.2 R3c: FloorTable.qrCode + regenerateTableQr
// YA están en el grafo (listTableQrCodes/regenerateTableQr migrados a GraphQL).
import { graphql } from '../../gql/index.js'

export const AdminFloorMapsQuery = graphql(`
  query AdminFloorMaps {
    floorMaps {
      id
      tenantId
      branchId
      name
      widthPx
      heightPx
      isDefault
      active
      createdAt
      updatedAt
      sections { id mapId name color sortOrder }
      tables { id mapId sectionId code capacity shape posX posY widthPx heightPx rotation status qrCode }
    }
  }
`)

export const AdminCreateFloorTableMutation = graphql(`
  mutation AdminCreateFloorTable($mapId: ID!, $input: PosCreateFloorTableInput!) {
    createFloorTable(mapId: $mapId, input: $input) {
      id mapId sectionId code capacity shape posX posY widthPx heightPx rotation status
    }
  }
`)

export const AdminUpdateFloorTableMutation = graphql(`
  mutation AdminUpdateFloorTable($mapId: ID!, $tableId: ID!, $input: PosUpdateFloorTableInput!) {
    updateFloorTable(mapId: $mapId, tableId: $tableId, input: $input) {
      id mapId sectionId code capacity shape posX posY widthPx heightPx rotation status
    }
  }
`)

export const AdminDeleteFloorTableMutation = graphql(`
  mutation AdminDeleteFloorTable($mapId: ID!, $tableId: ID!) {
    deleteFloorTable(mapId: $mapId, tableId: $tableId)
  }
`)

export const AdminCreateFloorSectionMutation = graphql(`
  mutation AdminCreateFloorSection($mapId: ID!, $input: PosCreateFloorSectionInput!) {
    createFloorSection(mapId: $mapId, input: $input) {
      id mapId name color sortOrder
    }
  }
`)

export const AdminDeleteFloorSectionMutation = graphql(`
  mutation AdminDeleteFloorSection($mapId: ID!, $sectionId: ID!) {
    deleteFloorSection(mapId: $mapId, sectionId: $sectionId)
  }
`)

// F6.2 R3c: regenera el token QR de una mesa por el grafo (IDOR-guard por RLS).
// Reemplaza el POST REST /v1/floor/tables/:id/qr/regenerate.
export const AdminRegenerateTableQrMutation = graphql(`
  mutation AdminRegenerateTableQr($tableId: ID!) {
    regenerateTableQr(tableId: $tableId) {
      id
      qrCode
    }
  }
`)
